// Category pills with tallies.
//
// The pills sit on the landing page beside the work they filter, rather than in
// the header, so the control is next to what it changes. They keep the header's
// type scale, so moving them out of the chrome didn't cost any consistency.
//
// The hairline above them is drawn by the section that holds them, not here:
// on the landing page it has to run the full width while the pills only take
// the first two columns and the figure hangs from it in the third.
//
// There is no "Selected work" label: a page of project names does not need to
// be told apart from anything else on the page, and the tallies already say
// how many there are. Pass `label` if a section ever needs naming.

import React from "react";
import {
  filterPillClass,
  homeFilterCountClass,
  homeSectionLabelClass,
} from "../../tokens";
import { FILTER_CATEGORIES } from "../../utils/projectFilters";

const LandingFilterBar = ({
  label = null,
  filters = FILTER_CATEGORIES,
  counts = {},
  activeFilter,
  onFilterChange,
}) => (
  <div className="flex flex-wrap items-center justify-between gap-x-8 gap-y-4">
    <nav
      aria-label="Project category filter"
      className="flex items-center gap-6 lg:gap-8"
    >
      {filters.map((filter) => {
        const isActive = filter === activeFilter;
        return (
          <button
            key={filter}
            type="button"
            onClick={() => onFilterChange?.(filter)}
            data-cursor="pointer"
            aria-pressed={isActive}
                className={filterPillClass(isActive)}
          >
            {filter}
            <span className={homeFilterCountClass}>{counts[filter]}</span>
            <span
              aria-hidden="true"
              className={`
                absolute -bottom-0.5 left-0 right-0 h-px bg-black dark:bg-white
                origin-left transition-transform duration-200
                ${isActive ? "scale-x-100" : "scale-x-0"}
              `}
            />
          </button>
        );
      })}
    </nav>

    {label && <p className={homeSectionLabelClass}>{label}</p>}
  </div>
);

export default LandingFilterBar;
